export default __webpack_public_path__ + "static/media/Ring of Chthonic Nightmares.43d3d113.jpg";